import React from 'react';

function ShoppingCarIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66364 2.49996C1.66364 2.95829 2.03864 3.33329 2.49697 3.33329H3.3303L6.3303 9.65829L5.2053 11.6916C4.59697 12.8083 5.39697 14.1666 6.66364 14.1666H15.8303C16.2886 14.1666 16.6636 13.7916 16.6636 13.3333C16.6636 12.875 16.2886 12.5 15.8303 12.5H6.66364L7.5803 10.8333H13.7886C14.4136 10.8333 14.9636 10.4916 15.247 9.97496L18.2303 4.56663C18.5386 4.01663 18.1386 3.33329 17.5053 3.33329H5.17197L4.61364 2.14163C4.4803 1.84996 4.1803 1.66663 3.86364 1.66663H2.49697C2.03864 1.66663 1.66364 2.04163 1.66364 2.49996ZM6.66364 15C5.74697 15 5.0053 15.75 5.0053 16.6666C5.0053 17.5833 5.74697 18.3333 6.66364 18.3333C7.5803 18.3333 8.3303 17.5833 8.3303 16.6666C8.3303 15.75 7.5803 15 6.66364 15ZM13.3386 16.6666C13.3386 15.75 14.0803 15 14.997 15C15.9136 15 16.6636 15.75 16.6636 16.6666C16.6636 17.5833 15.9136 18.3333 14.997 18.3333C14.0803 18.3333 13.3386 17.5833 13.3386 16.6666Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ShoppingCarIcon;
